import React from "react";
import { motion } from "framer-motion";
import { FileText, Wallet, Target, Cpu, ArrowDown, Users, Handshake } from "lucide-react";

const inputs = [
  { icon: FileText, label: "Campaign Brief", value: "Summer product launch" },
  { icon: Wallet, label: "Budget", value: "Defined range" },
  { icon: Target, label: "Requirements", value: "Niche · audience · performance signals" },
];

const talent = [
  { name: "Relevant Talent", tag: "High affinity", match: "94%" },
  { name: "Relevant Talent", tag: "Audience fit", match: "89%" },
  { name: "Relevant Talent", tag: "Strong performance", match: "86%" },
];

export const OrbitVisual = () => {
  return (
    <div data-testid="hero-orbit-visual" className="relative w-full max-w-md mx-auto">
      <div className="absolute inset-0 -z-10 blur-3xl opacity-70"
        style={{ background: "radial-gradient(circle at 50% 40%, rgba(37,99,235,0.28), transparent 65%)" }} />

      <p className="eyebrow mb-2">Campaign Brief</p>
      <div className="space-y-3">
        {inputs.map((it, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.2 + i * 0.15, duration: 0.6 }}
            className="glass rounded-xl px-4 py-3 flex items-center gap-3"
          >
            <span className="grid place-items-center h-9 w-9 rounded-lg bg-sky-500/15 border border-sky-400/25 text-sky-300">
              <it.icon size={17} />
            </span>
            <div className="min-w-0">
              <p className="text-[0.7rem] uppercase tracking-wider text-slate-500 font-mono">{it.label}</p>
              <p className="text-sm text-slate-200 truncate">{it.value}</p>
            </div>
          </motion.div>
        ))}
      </div>

      <div className="flex justify-center py-3 text-sky-400/70">
        <ArrowDown size={20} className="animate-float" />
      </div>

      {/* Campaign Intelligence core */}
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.7, duration: 0.7 }}
        className="relative mx-auto h-40 w-40 grid place-items-center"
      >
        <div className="absolute inset-0 rounded-full border border-white/10 orbit-ring-slow">
          <span className="absolute -top-1 left-1/2 h-2 w-2 -translate-x-1/2 rounded-full bg-cyan-300 shadow-[0_0_12px_rgba(56,189,248,0.9)]" />
        </div>
        <div className="absolute inset-4 rounded-full border border-sky-400/25 orbit-ring-fast">
          <span className="absolute top-1/2 -right-1 h-1.5 w-1.5 -translate-y-1/2 rounded-full bg-sky-300 shadow-[0_0_12px_rgba(56,189,248,0.9)]" />
        </div>
        <div className="pulse-core h-20 w-20 rounded-full grid place-items-center text-center"
          style={{ background: "radial-gradient(circle, rgba(37,99,235,0.55), rgba(14,165,233,0.15))", boxShadow: "0 0 40px rgba(37,99,235,0.55)" }}>
          <Cpu className="text-white" size={22} />
        </div>
      </motion.div>
      <p className="text-center mt-1 text-[0.7rem] uppercase tracking-[0.2em] font-mono text-sky-300">
        Campaign Intelligence
      </p>

      <div className="flex justify-center py-3 text-sky-400/70">
        <ArrowDown size={20} />
      </div>

      {/* Talent results */}
      <p className="eyebrow mb-2">Relevant Talent</p>
      <div className="space-y-2.5">
        {talent.map((c, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 1 + i * 0.15, duration: 0.6 }}
            className="glass rounded-xl px-4 py-3 flex items-center gap-3"
          >
            <span className="grid place-items-center h-9 w-9 rounded-lg bg-cyan-500/12 border border-cyan-400/25 text-cyan-300">
              <Users size={17} />
            </span>
            <div className="min-w-0 flex-1">
              <p className="text-sm text-slate-200">{c.name}</p>
              <p className="text-[0.7rem] text-slate-500">{c.tag}</p>
            </div>
            <span className="font-mono text-xs text-sky-300 shrink-0">{c.match}</span>
          </motion.div>
        ))}
      </div>

      <div className="flex justify-center py-3 text-sky-400/70">
        <ArrowDown size={20} />
      </div>
      <div className="glass rounded-xl px-4 py-3 flex items-center gap-3 border-sky-400/20">
        <span className="grid place-items-center h-9 w-9 rounded-lg bg-blue-500/15 border border-blue-400/25 text-blue-300">
          <Handshake size={17} />
        </span>
        <div>
          <p className="text-[0.7rem] uppercase tracking-wider text-slate-500 font-mono">Collaboration</p>
          <p className="text-sm text-slate-200">Paid · barter · agreed terms</p>
        </div>
      </div>
    </div>
  );
};
